import { render, staticRenderFns } from "./giftPackageHome.vue?vue&type=template&id=57a9a5f2&scoped=true&"
import script from "./giftPackageHome.vue?vue&type=script&lang=js&"
export * from "./giftPackageHome.vue?vue&type=script&lang=js&"
import style0 from "./giftPackageHome.vue?vue&type=style&index=0&id=57a9a5f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a9a5f2",
  null
  
)

export default component.exports